import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Aos from "aos";
import "aos/dist/aos.css";

function TestimonialSlider() {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    Aos.init({ duration: 2000 });

    const container3 = document.getElementById("testimonial-image-container");
    const handleMouseMove = (e) => {
      const offsetX1 = (e.clientX / window.innerWidth - 0.5) * 50;
      const offsetY1 = (e.clientY / window.innerHeight - 0.5) * 50;
      container3.style.transform = `translate(${offsetX1}px, ${offsetY1}px)`;
    };
    document.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div className="relative">
      <div
        id="testimonial-image-container"
        className="absolute bottom-70"
        style={{ left: "-50px" }}
      >
        <img
          src="https://demo.edublink.co/wp-content/uploads/2023/06/shape-02.png"
          className="h-48 w-48"
          alt="Moving shape"
        />
      </div>
      <div className="flex flex-wrap justify-center items-start mx-auto max-w-[1120px] relative">
        <div
          className="w-full lg:w-1/3 lg:pr-10 mb-10 lg:mb-0 text-left"
          data-aos="fade-up"
        >
          <div className="text-center lg:text-left mb-10">
            <h3 className="uppercase text-sm tracking-widest text-gray-500 mb-2">
              Testimonials
            </h3>
            <h1 className="text-4xl font-semibold">
              What Our Students Have To Say
            </h1>
            {/* <p className="text-gray-600 mt-4 mb-10">
              Lorem ipsum dolor sit amet consectetur adipiscing elit sed eiusmod
              tempor incididunt labore dolore magna aliqua enim minim ve.
            </p> */}
            {/* <button className="bg-teal-500 text-white px-6 py-2 rounded-md hover:bg-teal-600 transition duration-300">
              View All
            </button> */}
          </div>
        </div>
        <div className="w-full lg:w-2/3 p-10 md:p-4 bg-white rounded-lg shadow-lg text-center">
          <Slider
            {...settings}
            className="space-x-4 flex justify-center items-center"
          >
            {testimonials.map((testimonial, index) => (
              <div key={index} className="p-0 flex justify-center">
                <div
                  className="group bg-white border border-solid border-gray-300 rounded-xl p-6 transition-all duration-500 mx-auto hover:shadow-md overflow-hidden"
                  style={{ width: "100%", height: "380px" }}
                >
                  <div className="flex items-center gap-5 mb-4">
                    {/* <img
                      className="h-14 w-14 rounded-full border border-gray-200"
                      src={testimonial.avatar}
                      alt="avatar"
                    /> */}
                    <div>
                      <h5 className="text-lg font-semibold text-gray-900 transition-all duration-500 mb-1">
                        {testimonial.name}
                      </h5>
                     
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center mb-3 gap-2 text-amber-500 transition-all duration-500">
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 18 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.10326 1.31699C8.47008 0.57374 9.52992 0.57374 9.89674 1.31699L11.7063 4.98347C11.8519 5.27862 12.1335 5.48319 12.4592 5.53051L16.5054 6.11846C17.3256 6.23765 17.6531 7.24562 17.0596 7.82416L14.1318 10.6781C13.8961 10.9079 13.7885 11.2389 13.8442 11.5632L14.5353 15.5931C14.6754 16.41 13.818 17.033 13.0844 16.6473L9.46534 14.7446C9.17402 14.5915 8.82598 14.5915 8.53466 14.7446L4.91562 16.6473C4.18199 17.033 3.32456 16.41 3.46467 15.5931L4.15585 11.5632C4.21148 11.2389 4.10393 10.9079 3.86825 10.6781L0.940384 7.82416C0.346867 7.24562 0.674378 6.23765 1.4946 6.11846L5.28462 5.53051C5.61144 5.48319 5.89297 5.27862 6.03863 4.98347L7.84817 1.31699Z"
                          fill="currentColor"
                        />
                      </svg>
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 18 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.10326 1.31699C8.47008 0.57374 9.52992 0.57374 9.89674 1.31699L11.7063 4.98347C11.8519 5.27862 12.1335 5.48319 12.4592 5.53051L16.5054 6.11846C17.3256 6.23765 17.6531 7.24562 17.0596 7.82416L14.1318 10.6781C13.8961 10.9079 13.7885 11.2389 13.8442 11.5632L14.5353 15.5931C14.6754 16.41 13.818 17.033 13.0844 16.6473L9.46534 14.7446C9.17402 14.5915 8.82598 14.5915 8.53466 14.7446L4.91562 16.6473C4.18199 17.033 3.32456 16.41 3.46467 15.5931L4.15585 11.5632C4.21148 11.2389 4.10393 10.9079 3.86825 10.6781L0.940384 7.82416C0.346867 7.24562 0.674378 6.23765 1.4946 6.11846L5.28462 5.53051C5.61144 5.48319 5.89297 5.27862 6.03863 4.98347L7.84817 1.31699Z"
                          fill="currentColor"
                        />
                      </svg>
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 18 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.10326 1.31699C8.47008 0.57374 9.52992 0.57374 9.89674 1.31699L11.7063 4.98347C11.8519 5.27862 12.1335 5.48319 12.4592 5.53051L16.5054 6.11846C17.3256 6.23765 17.6531 7.24562 17.0596 7.82416L14.1318 10.6781C13.8961 10.9079 13.7885 11.2389 13.8442 11.5632L14.5353 15.5931C14.6754 16.41 13.818 17.033 13.0844 16.6473L9.46534 14.7446C9.17402 14.5915 8.82598 14.5915 8.53466 14.7446L4.91562 16.6473C4.18199 17.033 3.32456 16.41 3.46467 15.5931L4.15585 11.5632C4.21148 11.2389 4.10393 10.9079 3.86825 10.6781L0.940384 7.82416C0.346867 7.24562 0.674378 6.23765 1.4946 6.11846L5.28462 5.53051C5.61144 5.48319 5.89297 5.27862 6.03863 4.98347L7.84817 1.31699Z"
                          fill="currentColor"
                        />
                      </svg>
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 18 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.10326 1.31699C8.47008 0.57374 9.52992 0.57374 9.89674 1.31699L11.7063 4.98347C11.8519 5.27862 12.1335 5.48319 12.4592 5.53051L16.5054 6.11846C17.3256 6.23765 17.6531 7.24562 17.0596 7.82416L14.1318 10.6781C13.8961 10.9079 13.7885 11.2389 13.8442 11.5632L14.5353 15.5931C14.6754 16.41 13.818 17.033 13.0844 16.6473L9.46534 14.7446C9.17402 14.5915 8.82598 14.5915 8.53466 14.7446L4.91562 16.6473C4.18199 17.033 3.32456 16.41 3.46467 15.5931L4.15585 11.5632C4.21148 11.2389 4.10393 10.9079 3.86825 10.6781L0.940384 7.82416C0.346867 7.24562 0.674378 6.23765 1.4946 6.11846L5.28462 5.53051C5.61144 5.48319 5.89297 5.27862 6.03863 4.98347L7.84817 1.31699Z"
                          fill="currentColor"
                        />
                      </svg>
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 18 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.10326 1.31699C8.47008 0.57374 9.52992 0.57374 9.89674 1.31699L11.7063 4.98347C11.8519 5.27862 12.1335 5.48319 12.4592 5.53051L16.5054 6.11846C17.3256 6.23765 17.6531 7.24562 17.0596 7.82416L14.1318 10.6781C13.8961 10.9079 13.7885 11.2389 13.8442 11.5632L14.5353 15.5931C14.6754 16.41 13.818 17.033 13.0844 16.6473L9.46534 14.7446C9.17402 14.5915 8.82598 14.5915 8.53466 14.7446L4.91562 16.6473C4.18199 17.033 3.32456 16.41 3.46467 15.5931L4.15585 11.5632C4.21148 11.2389 4.10393 10.9079 3.86825 10.6781L0.940384 7.82416C0.346867 7.24562 0.674378 6.23765 1.4946 6.11846L5.28462 5.53051C5.61144 5.48319 5.89297 5.27862 6.03863 4.98347L7.84817 1.31699Z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                    <p className="text-gray-600 overflow-hidden text-ellipsis">
                      {testimonial.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

const testimonials = [
  {
    text: "Mr. Rade impressed me with his learning method that helped me surpass my limit in English vocab, grammar, pronunciation, etc. His knowledge of every detailed aspect of language education, especially English, gives me more interest in studying and improving it day by day. Ten out of ten.",
    name: "Kien Nguyen Trung, Ho Chi Minh, Vietnam",
    date: "January 8, 2023",
    avatar: "https://pagedone.io/asset/uploads/1696229969.png",
  },
  {
    text: "Instead of trying to learn by heart all the grammar structures and new words, I switched to learning through listening and speaking. That's when I found a class with teacher Rade. Every week, I had 2-3 sessions with him, each lasting 30 minutes. We had conversations for almost 2 years. Thanks to that time, I made a leap from being hopeless at English to being able to speak English as I do today.",
    name: "Thanh Mai, Hanoi, Vietnam ",
    date: "June 27, 2018",
    avatar: "https://pagedone.io/asset/uploads/1696229969.png",
  },
  {
    text: "I am a doctor in Ho Chi Minh City, and although my job does not require much English communication, I am still studying with Teacher Rade.Now, my children are studying abroad in Australia. Thanks to learning English with Teacher Rade, they integrated smoothly and did not have to relearn the language like some of their classmates. My daughter is still taking classes with him.",
    name: "Mrs. Hanh Ngo, Ho Chi Minh, Vietnam",
    date: "November 27, 2019",
    avatar: "https://pagedone.io/asset/uploads/1696229969.png",
  },
 
];

export default TestimonialSlider;
